import * as React from 'react';
import _ from 'lodash';

import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';
import { BlockErrorBoundary } from '../../../containers/BlockErrorBoundary';
import { IAgentCardModerationInfo } from '../../../types/agentCard';

export const getSuperAgentBadge = (moderationInfo: IAgentCardModerationInfo | null) => {
  const showSuperAgent = _.get(moderationInfo, 'qualityLevelInfo.showSuperAgent', null);
  const levelName = _.get(moderationInfo, 'qualityLevelInfo.levelName', '');

  if (!showSuperAgent) {
    return null;
  }

  /* Бейдж декоративный, а текст тултипа приходит из Runtime Settings: при значении
     неожиданного типа падение внутри не должно уносить блок «О риелторе». */
  return (
    <BlockErrorBoundary>
      <SuperAgentLevelViewContainer levelName={levelName} />
    </BlockErrorBoundary>
  );
};
